// traduzir para Francês (fr-FR)
export const bars = {
	title: "Bars",
	description: "Les opérateurs liés à ces bars auront ces produits disponibles",
	actions: {
		linkBars: "Ajouter aux bars",
		unlinkBars: "Dissocier le bar",
		linkBar: "Lier le bar",
		unlinkBar: "Dissocier le bar",
		next: "Suivant",
		back: "Retour",
	},
	notifications: {
		success: "Produit lié avec succès aux bars sélectionnés.",
		error: "Certaines liaisons ont échoué. Veuillez réessayer plus tard.",
		genericError:
			"Erreur lors de la liaison du produit aux bars. Veuillez réessayer plus tard.",
		unlinkSuccess: "Produit dissocié avec succès du bar.",
		genericUnlinkError:
			"Erreur lors de la dissociation du produit du bar. Veuillez réessayer plus tard.",
	},
	unlinkBarsConfirmation: {
		title: "Dissocier le bar",
		message:
			"Voulez-vous supprimer le lien avec ce bar ? Si oui, votre produit ne sera plus disponible à la consommation dans le bar.",
		confirm: "Dissocier le bar",
		cancel: "Annuler",
	},
	labels: {
		linkedBars: "Bars liés",
		optional: "Optionnel",
		selectBars: "Choisissez les bars où votre produit sera actif.",
		stock: "Stock",
		ip: "IP Imprimante",
	},
	fields: {
		searchLabel: "Bars disponibles",
		searchPlaceholder: "Rechercher un bar",
	},
	emptyState: {
		title: "Aucun bar lié pour le moment",
		description: "Ajoutez des bars pour rendre ce produit disponible à la consommation.",
	},
};
